import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer-section">
      <div className="container">
        <div className="footer-content">
          <div className="footer-brand">
            <img src="/assets/bh_logo.png" alt="BH La Marca del Panadero" className="footer-logo" />
            <p>&copy; {new Date().getFullYear()} BH La Marca del Panadero. Todos los derechos reservados.</p>
          </div>
          <nav className="footer-nav">
            <h4>Navegación</h4>
            <ul>
              <li><a href="#inicio">Inicio</a></li>
              <li><a href="#product-showcase-section">Máquinas</a></li>
              <li><a href="#contact-section">Servicios</a></li>
              <li><a href="#about-us-section">Nosotros</a></li>
              <li><a href="#contact-section">Contacto</a></li>
            </ul>
          </nav>
          <div className="footer-contact">
            <h4>Contacto</h4>
            <p>Calle 824 2531, San Francisco Solano, Quilmes, Buenos Aires</p>
            <p>Teléfono: +54 11 6208-1047</p>
            <p>Email: info@batistta.com.ar</p>
          </div>
          <div className="footer-map">
            <h4>Ubicación</h4>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3275.6453986068647!2d-58.30907488423271!3d-34.79374007353106!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95a32b26c71b12b3%3A0x6a8b7c3d2f9a9c40!2sCalle%20824%202531%2C%20San%20Francisco%20Solano%2C%20Provincia%20de%20Buenos%20Aires!5e0!3m2!1sen!2sar!4v1678912345678!5m2!1sen!2sar"
              width="100%"
              height="200"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Ubicación de BH La Marca del Panadero"
            ></iframe>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
